export const office_location = [
  { name: 'Prishtinë HQ', value: 'Prishtinë HQ' },
  { name: 'Ferizaj', value: 'Ferizaj' },
  { name: 'Vushtrri', value: 'Vushtrri' },
  { name: 'Prizren', value: 'Prizren' },
  { name: 'HO-Prishtinë', value: 'HO-Prishtinë' },
  { name: 'HO-Ferizaj', value: 'HO-Ferizaj' },
  { name: 'HO-Vushtrri', value: 'HO-Vushtrri' },
  { name: 'HO-Prizren', value: 'HO-Prizren' }
]
